import type {
  Metadata,
  Prompt,
  UserPrompt,
  WorkgroupUserPrompt,
} from "./types";
import { AllowedExtensionList, AllowedJobTypeList } from "./types";

/**
 * Check if the prompt is a BizChat prompt
 * @param prompt Prompt
 * @returns true if the prompt is a BizChat prompt
 */
export const isBizChatPrompt = (prompt: Prompt) => {
  return prompt.Products.indexOf("BizChat") > -1;
};

/**
 * Check if the prompt is a CWC prompt
 * @param prompt Prompt
 * @returns true if the prompt is a CWC prompt
 */
export const isCWCPrompt = (prompt: Prompt) => {
  return prompt.Products.includes("CWC");
};

/**
 * Check if the prompt is a User prompt
 * @param prompt Prompt
 * @returns true if the prompt is a User authored prompt
 */
export const isUserPrompt = (
  prompt: Prompt
): prompt is UserPrompt | WorkgroupUserPrompt => {
  return prompt.Origin === "User";
};

/**
 * Check if the prompt is a en extension prompt
 * @param prompt Prompt
 * @returns true if the prompt is anextension prompt
 */
export const isExtensionPrompt = (prompt: Prompt) => {
  return !!prompt && !!prompt.Origin && AllowedExtensionList.has(prompt.Origin);
};

/**
 * Extract job type from the prompt
 * @param prompt Prompt
 * @returns job type list
 */
export const extractJobTypes = (prompt: Prompt): string[] => {
  // example meta data looks like this { name: "Industry", value: "Human Resources" }
  // go through all meta data from a prompt, and extract values of each meta data to a list only if the name is in the allowed list.
  const jobTypes: string[] = [];
  if (prompt && prompt.Metadata) {
    prompt.Metadata.forEach((item: Metadata) => {
      if (AllowedJobTypeList.has(item.Name)) {
        jobTypes.push(item.Value);
      }
    });
  }

  return jobTypes;
};
